import React from "react";
import "./banner.scss";
import Tvl from "./Tvl";
import { Link } from "react-router-dom";

const Banner = () => {
  return (
    <>
      <div className="outter_layer">
        <section className="banner-main">
          <img
            src="\assets\homepage\banner\banner-shadow.png"
            alt="img"
            className="img-fluid banner-shadow"
          />
          <video
            className="main-banner-video"
            muted="muted"
            playsinline="playsinline"
            autoPlay
            loop
            width="100%"
            id="myVideo"
          >
            <source src="\assets\bannervideo.mp4" type="video/mp4" />
          </video>
          <div className="custom-container">
            <div className="inner-banner">
              <div className="left-side">
                <div>
                  <h2>A prediction markets protocol for the agentic era.</h2>
                  <p>
                    Rain is the engine behind the next generation of forecasting. We empower creators and AI agents to architect their own prediction markets platforms.
                  </p>
                  <div className="buttons-both">
                    <Link to="/builders#program">
                      <button className="start">Start Building</button>
                    </Link>
                    <Link to="/apps">
                      <button className="explore">Explore Apps</button>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="right-side">
                <img
                  src="\assets\homepage\banner\bannerright.png"
                  className="img-fluid"
                  style={{ maxWidth: "517px" }}
                />
              </div>
            </div>
          </div>
        </section>
      </div>

      <Tvl />
    </>
  );
};

export default Banner;
